/**
 * @generated SignedSource<<bd018f52a26667de692642d0f5cbc56b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrawingSetAnnotationUpdateInput = {
  drawingSetId?: string | null | undefined;
  drawingSheetId?: string | null | undefined;
  type?: string | null | undefined;
  xfdf?: string | null | undefined;
};
export type updateDrawingSetAnnotationMutation$variables = {
  id: string;
  input: DrawingSetAnnotationUpdateInput;
};
export type updateDrawingSetAnnotationMutation$data = {
  readonly updateDrawingSetAnnotation: {
    readonly " $fragmentSpreads": FragmentRefs<"drawingSetAnnotationFragment">;
  } | null | undefined;
};
export type updateDrawingSetAnnotationMutation = {
  response: updateDrawingSetAnnotationMutation$data;
  variables: updateDrawingSetAnnotationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateDrawingSetAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotation",
        "kind": "LinkedField",
        "name": "updateDrawingSetAnnotation",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "drawingSetAnnotationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateDrawingSetAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotation",
        "kind": "LinkedField",
        "name": "updateDrawingSetAnnotation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdById",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "drawingSheetId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xfdf",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9eba9b4950e67a981966299390bb58a4",
    "id": null,
    "metadata": {},
    "name": "updateDrawingSetAnnotationMutation",
    "operationKind": "mutation",
    "text": "mutation updateDrawingSetAnnotationMutation(\n  $id: ID!\n  $input: DrawingSetAnnotationUpdateInput!\n) {\n  updateDrawingSetAnnotation(id: $id, input: $input) {\n    ...drawingSetAnnotationFragment\n    id\n  }\n}\n\nfragment drawingSetAnnotationFragment on DrawingSetAnnotation {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  drawingSheetId\n  type\n  xfdf\n}\n"
  }
};
})();

(node as any).hash = "dbbe5418c3c163d527a9da11abdb8fb3";

export default node;
